<template>
  <v-text-field
    ref="numField"
    v-model="num"
    :rules="rulesApplied"
    v-bind="[$attrs, $props]"
    v-on="listeners"
  />
</template>

<script>
const rules = new Map([
  [ 'required', v => (v !== '' && v !== null) || '必須項目です。' ],
  [ 'above1', v => (v > 0 || v === '' || v === null) || '１以上で入力してください。' ]
])
export default {
  props: {
    value: {
      type: [Number, String],
      default: () => null
    },
    rules: {
      type: Array,
      default: () => []
    },
    max: {
      type: [Number, String],
      default: () => null
    },
    min: {
      type: [Number, String],
      default: () => null
    }
  },
  computed: {
    listeners () {
      const { input, ...listeners } = this.$listeners
      return listeners
    },
    num: {
      get () {
        return this.value
      },
      set (num) {
        if (num === null || num === '') {
          this.$emit('input', null)
          return
        }

        // 全角を半角に変更。結果が数字以外ならフィールドを空にする。（全角の場合keydownイベントでcharを確認できないため、インプットのみをキャンセルすることができなかった）
        num = Number(num.normalize('NFKC'))

        if (!num) {
          this.$refs.numField.lazyValue = null
          this.$emit('input', null)
          return
        }

        num = Math.max(num, 0)
        const max = Number(this.max)
        const min = Number(this.min)
        if (max) num = Math.min(num, max)
        if (min) num = Math.max(num, min)

        this.$refs.numField.lazyValue = num
        this.$emit('input', num)
      }
    },
    rulesApplied () {
      return this.rules.map(r => rules.get(r))
    }
  }
}
</script>
<style lang="scss" scoped>

/* Chrome, Safari, Edge, Opera */
/deep/input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
-webkit-appearance: none;
margin: 0;
}

/* Firefox */
/deep/input[type='number'] {
    -moz-appearance:textfield;
}

</style>
